import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;
const EmptyService = ({ togglePopup }) => {
    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.8335 12.8333V9.16663H26.2779V12.8333H1.8335ZM1.8335 22H33.9168V18.3333H1.8335V22ZM18.9446 31.1666H1.8335V27.5H18.9446V31.1666ZM32.2539 35.9729C34.1087 37.8269 27.5 31.2296 27.5 31.2296L29.9806 28.7384L32.2503 31.0082L39.8045 23.4681L42.2851 25.9557L37.2677 30.9625L32.2503 35.9694L32.2539 35.9729Z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Set up your Services & Pricing
            </CreateText>

            <div style={{ 
                textAlign: 'center', 
                maxWidth: '500px', 
                marginBottom: '32px',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                fontFamily: 'Poppins, sans-serif'
            }}>
                Add your services and pricing that will be shown on your business profile. 
                Configure which services are bookable by patients for online appointment scheduling.
            </div>

            <div>
                <ButtonLarge onClick={togglePopup} className="button">
                    Add a Service
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
};

export default EmptyService;
